export default __webpack_public_path__ + "static/1303-bfbde6f4aedcd62da1a2d6acc38bf882.gif";